<template>
    <b-container style="margin-top: 50px">
        <b-row style="margin: 50px 0;">
            <b-col class="d-flex justify-content-between pr-5 pl-5">
                <b-icon-person-fill style="width: 60px; height: 60px; align-self: center"></b-icon-person-fill>
                <div>
                    <h1>{{ statsData.totalUsers }}</h1>
                    <p>Σύνολο Χρηστών</p>
                </div>
            </b-col>
            <b-col class="d-flex justify-content-between pr-5 pl-5">
                <b-icon-person-check-fill style="width: 60px; height: 60px; align-self: center" variant="success"></b-icon-person-check-fill>
                <div>
                    <h1>{{ statsData.totalVerifiedUsers }}</h1>
                    <p>Σύνολο Επιβεβαιωμένων Χρηστών</p>
                </div>
            </b-col>
            <b-col class="d-flex justify-content-between pr-5 pl-5">
                <b-icon-person-plus-fill style="width: 60px; height: 60px; align-self: center" variant="danger"></b-icon-person-plus-fill>
                <div>
                    <h1>{{ statsData.notVerifiedUsers }}</h1>
                    <p>Σύνολο Μη Επιβεβαιωμένων Χρηστών</p>
                </div>
            </b-col>
        </b-row>
        <b-row style="margin: 50px 0;">
            <b-col>
                <b-list-group style="text-align: left">
                    <b-list-group-item class="d-flex justify-content-between"><b>Επάγγελμα</b> <span><b>Έφεδροι</b></span></b-list-group-item>
                    <b-list-group-item v-for="item in statsData.epaggelmaList" :key="item.value" class="d-flex justify-content-between">
                        <span v-if="item.value == '' || item.value == ' '">ΑΓΝΩΣΤΟ</span>
                        <span v-else>{{item.value}}</span>
                        <span><b>{{item.userCount}}</b></span>
                    </b-list-group-item>
                </b-list-group>
            </b-col>
            <b-col>
                <b-list-group style="text-align: left">
                    <b-list-group-item class="d-flex justify-content-between"><b>Μονάδα</b> <span><b>Έφεδροι</b></span></b-list-group-item>
                     <b-list-group-item v-for="item in statsData.monadaEpistratefsisList" :key="item.value" class="d-flex justify-content-between">
                        <span v-if="item.value == '' || item.value == ' '">ΑΓΝΩΣΤΟ</span>
                        <span v-else>{{item.value}}</span>
                        <span><b>{{item.userCount}}</b></span>
                    </b-list-group-item>
                </b-list-group>
            </b-col>
            <b-col>
                <b-list-group style="text-align: left">
                    <b-list-group-item class="d-flex justify-content-between"><b>Εκπαίδευση</b> <span><b>Έφεδροι</b></span></b-list-group-item>
                    <b-list-group-item v-for="item in statsData.ekpaidefsiList" :key="item.value" class="d-flex justify-content-between">
                        <span v-if="item.value == '' || item.value == ' '">ΑΓΝΩΣΤΟ</span>
                        <span v-else>{{item.value}}</span>
                        <span><b>{{item.userCount}}</b></span>
                    </b-list-group-item>
                </b-list-group>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
export default {
    name: 'Statistics',
    data() {
        return {
            total: 0
        }
    },
    props: {
        statsData: Object
    }
}
</script>